module.exports = __webpack_public_path__ + "static/media/username.6a8b206b.svg";